import { Control, useController } from 'react-hook-form';

import { AcceptCampaignFormValues } from './types';
import {
  createMaxLengthValidator,
  createRequiredValidator,
  isValidInput,
} from '@/utils/validator';

export const useControllers = (
  control: Control<AcceptCampaignFormValues, any, AcceptCampaignFormValues>
) => {
  const {
    field: { value: excludedMnoIds, onChange: setExcludedMnoIds },
    fieldState: { error: excludedMnoIdsError },
  } = useController({
    control,
    name: 'excludedMnoIds',
  });
  const {
    field: {
      value: explanation,
      onChange: setExplanation,
      onBlur: validateExplanation,
    },
    fieldState: { error: explanationError },
  } = useController({
    control,
    name: 'explanation',
    disabled: excludedMnoIds.length < 1,
    rules: {
      validate: {
        isRequired: createRequiredValidator('Please enter explanation'),
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(2048),
      },
    },
  });

  return {
    excludedMnoIds,
    setExcludedMnoIds,
    excludedMnoIdsError,
    explanation,
    setExplanation,
    validateExplanation,
    explanationError,
  };
};
